module.exports = __webpack_public_path__ + "eff7245ddd1dbd0cf3a0b3892b9642a1.png";